import {FlexPage} from '@hconnect/common/components'
import {sideCardSize, tableWithOutSideCard, tableWithSideCard} from '@hconnect/common/consts'
import {Grid, useMediaQuery, useTheme} from '@mui/material'

type LayoutProps = {
  templatesListSlot: React.ReactNode
  templateDetailsSlot?: React.ReactNode
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
}

export const ChecklistsTemplatesMobileLayout = ({
  templatesListSlot,
  templateDetailsSlot,
  titleSlot,
  aboveTitleSlot
}: LayoutProps) => {
  const theme = useTheme()
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  const isTemplatePreviewDisplayed = !!templateDetailsSlot
  const isListHidden = isPhone && isTemplatePreviewDisplayed

  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
    >
      <Grid container spacing={2}>
        {!isListHidden && (
          <Grid
            item
            {...(isTemplatePreviewDisplayed ? {...tableWithSideCard, sm: 6} : tableWithOutSideCard)}
          >
            {templatesListSlot}
          </Grid>
        )}
        {isTemplatePreviewDisplayed && (
          <Grid item {...sideCardSize} sm={6}>
            {templateDetailsSlot}
          </Grid>
        )}
      </Grid>
    </FlexPage>
  )
}
